import { useEffect } from "react";
import posthog from "@/lib/posthog";

export function useComponentAnalytics(componentName: string, extraProps?: Record<string, any>) {
  useEffect(() => {
    posthog.capture("component_viewed", { component: componentName, ...extraProps });
  }, [componentName]);
} 